export default __webpack_public_path__ + "cbb4671876743640adb766e314bba20b.png";